import { api } from '../api';

/** One "Got it" on a critical-control-point step, as the API stores it. */
export interface CcpAcknowledgement {
  id: number;
  recipeId: number;
  step: number;
  userId: number;
  cookingSessionId: number | null;
  /** ISO 8601, set by the server. */
  acknowledgedAt: string;
}

export const recipeCcpRequests = {
  /**
   * Records that the signed-in user read the warning on a step. `step` is the
   * step's own number (its place in the list when it has none). Every call adds
   * a row; the user and the time come from the server.
   */
  acknowledge: (recipeId: number, step: number, cookingSessionId?: number) =>
    api.post<CcpAcknowledgement>(
      `/recipes/${recipeId}/steps/${step}/ccp-acknowledgements`,
      cookingSessionId != null ? { cookingSessionId } : {},
    ),
};
